import { colors } from "../../colors";

import {
  ControlProps,
  CSSObjectWithLabel,
  GroupBase,
  OptionProps,
  StylesConfig,
} from "react-select";

export const getSelectStyles = ({
  isMulti,
  errorMessage,
}: {
  isMulti?: boolean;
  errorMessage?: string;
}) => {
  const getCustomControlStyle = (
    state: ControlProps<unknown, boolean, GroupBase<unknown>>
  ): CSSObjectWithLabel => ({
    padding: "8px",
    display: "flex",
    flexWrap: "nowrap",
    height: isMulti ? "auto" : "38px",
    outline:
      state.isFocused && !errorMessage
        ? `2px solid rgba(70, 127, 207, 0.2)`
        : state.isFocused && errorMessage
        ? `2px solid rgba(220, 20, 45, 0.2)`
        : "none",
    boxShadow: "none",
    border: `1px solid ${
      state.isFocused && !errorMessage
        ? "rgba(70, 127, 207, 1)"
        : errorMessage
        ? colors.errorDark
        : colors.greyBorder
    }`,
    ":hover": {
      border: `1px solid ${
        state.isFocused && !errorMessage
          ? "rgba(70, 127, 207, 1)"
          : errorMessage
          ? colors.errorDark
          : colors.greyBorder
      }`,
    },
  });

  const getCustomOptionStyle = (
    state: OptionProps<unknown, boolean, GroupBase<unknown>>
  ): CSSObjectWithLabel => ({
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    gap: "8px",
    padding: "8px",
    fontFamily: "Inter",
    fontSize: "14px",
    borderRadius: "4px",
    cursor: state.isDisabled ? "default" : "pointer",
    color: state.isDisabled ? colors.greyBorder : colors.textPrimary,
    backgroundColor: state.isSelected
      ? colors.ctaLight
      : state.isFocused
      ? colors.whiteHover
      : colors.white,
    ":hover": {
      backgroundColor: state.isDisabled
        ? colors.white
        : state.isSelected
        ? colors.ctaLight
        : colors.whiteHover,
    },
  });

  const menuListCustomStyle: CSSObjectWithLabel = {
    display: "flex",
    flexDirection: "column",
    gap: "4px",
    padding: "8px",
  };

  const multiValueRemoveCustomStyle: CSSObjectWithLabel = {
    borderRadius: "4px",
    backgroundColor: colors.ctaMain,
    fontFamily: "Inter",
    display: "flex",
    flexDirection: "row",
    textAlign: "center",
    alignItems: "center",
    marginRight: "2px",
    padding: "2px 2px",
    background: colors.whiteHover,
    border: `1px solid ${colors.greyBorder}`,
  };

  const multiValueLabelCustomStyle: CSSObjectWithLabel = {
    fontFamily: "Inter",
    fontSize: "12px",
    marginRight: "4px",
  };
  const multiValueCustomStyle: CSSObjectWithLabel = {
    borderRadius: "4px",
    backgroundColor: colors.ctaMain,
    display: "flex",
    flexDirection: "row",
    textAlign: "center",
    alignItems: "center",
    marginLeft: "2px",
    marginTop: "2px",
    marginBottom: "2px",
    marginRight: "2px",
    padding: "2px 4px",
    background: colors.whiteHover,
    border: `1px solid ${colors.greyBorder}`,
  };
  const inputCustomStyle: CSSObjectWithLabel = {
    fontFamily: "Inter",
    fontSize: "14px",
    color: colors.textPrimary,
    ...(isMulti
      ? {}
      : {
          display: "flex",
          minWidth: "min-content",
          alignItems: "center",
          textAlign: "left",
        }),
  };
  const singleValueCustomStyle: CSSObjectWithLabel = {
    ...inputCustomStyle,
    minWidth: "max-content",
  };
  const placeholderCustomStyle: CSSObjectWithLabel = {
    fontFamily: "Inter",
    fontSize: "14px",
    color: colors.textSecondary,
    ...(isMulti
      ? {}
      : { display: "flex", textWrap: "nowrap", alignItems: "center" }),
  };
  const valueContainerCustomStyle: CSSObjectWithLabel = {
    display: "flex",
    flexDirection: "row",
    textAlign: "center",
  };

  const styles: StylesConfig<unknown, boolean, GroupBase<unknown>> = {
    control: (baseStyle, state) => ({
      ...baseStyle,
      ...getCustomControlStyle(state),
    }),
    singleValue: () => singleValueCustomStyle,
    valueContainer: (baseStyle) => ({
      ...(isMulti ? baseStyle : valueContainerCustomStyle),
    }),
    placeholder: (baseStyle) => ({
      ...(isMulti && baseStyle),
      ...placeholderCustomStyle,
    }),
    input: (baseStyle) => ({
      ...(isMulti && baseStyle),
      ...inputCustomStyle,
    }),
    multiValue: () => multiValueCustomStyle,
    multiValueRemove: () => multiValueRemoveCustomStyle,
    multiValueLabel: () => multiValueLabelCustomStyle,
    menuPortal: (base) => ({
      ...base,
      zIndex: 1000000,
    }),
    menuList: (baseStyle) => ({
      ...baseStyle,
      ...menuListCustomStyle,
    }),
    option: (baseStyle, state) => ({
      ...baseStyle,
      ...getCustomOptionStyle(state),
    }),
  };

  return styles;
};
